import React from 'react';
import Navbar from '../components/Navbar';
import './Halloween2026.css';

const Halloween2026 = () => (
  <div className="halloween-2026-page">
    <Navbar />
    <main className="halloween-2026-game" aria-label="尖叫之夜互动小说">
      <iframe
        src="/halloween2026-game/index.html"
        title="尖叫之夜互动小说"
        allow="autoplay; fullscreen"
      />
    </main>
  </div>
);

export default Halloween2026;
